(function () {
  var root = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal --------------------------------------------- */
  var targets = [].slice.call(root.querySelectorAll('.dp-reveal'));
  function show(el) { el.style.opacity = '1'; el.style.transform = 'none'; }
  if (!reduce) targets.forEach(function (el) { el.style.opacity = '0'; el.style.transform = 'translateY(26px)'; });
  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  } else { targets.forEach(show); targets = []; }
  function sweep() {
    var lim = window.innerHeight * 0.94;
    targets = targets.filter(function (el) {
      if (el.getBoundingClientRect().top >= lim) return true;
      show(el); if (io) io.unobserve(el); return false;
    });
  }
  var raf = null;
  window.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; sweep(); }); }, { passive: true });
  window.addEventListener('resize', sweep);
  requestAnimationFrame(sweep);

  /* ---------- toast -------------------------------------------------------- */
  var toast = root.querySelector('[data-dp-toast]'), tt = null;
  function flash(m) {
    if (!toast) return;
    toast.textContent = m; toast.classList.add('is-on');
    clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('is-on'); }, 2350);
  }

  /* ---------- gallery: thumbs scroll the main rail to the matching slide --- */
  var gal = root.querySelector('[data-dp-gal]');
  if (gal) {
    var slides = [].slice.call(gal.querySelectorAll('[data-dp-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-dp-thumb]'));
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var target = slides[i];
        if (target) gal.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        thumbs.forEach(function (o, j) { o.setAttribute('aria-pressed', String(i === j)); });
      });
    });
    if (slides.length > 1) {
      var galTick = null;
      gal.addEventListener('scroll', function () {
        if (galTick) return;
        galTick = requestAnimationFrame(function () {
          galTick = null;
          var idx = Math.round(gal.scrollLeft / gal.clientWidth);
          thumbs.forEach(function (o, j) { o.setAttribute('aria-pressed', String(idx === j)); });
        });
      }, { passive: true });
    }
  }

  /* ---------- variants: options -> matching variant, price/availability --- */
  var buyRoot = root.querySelector('[data-dp-buy]');
  if (buyRoot) {
    var variants = JSON.parse(buyRoot.querySelector('[data-dp-variants]').textContent || '[]');
    var moneyFormat = buyRoot.getAttribute('data-money-format') || '${{amount}}';
    var optionButtons = [].slice.call(buyRoot.querySelectorAll('[data-dp-opt]'));
    var priceEl = buyRoot.querySelector('[data-dp-price]');
    var wasEl = buyRoot.querySelector('[data-dp-was]');
    var totalEls = [].slice.call(root.querySelectorAll('[data-dp-total]'));
    var variantIdEl = buyRoot.querySelector('[data-dp-variant-id]');
    var subEl = root.querySelector('[data-dp-sticksub]');

    function fmtMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }

    /* Seed the selected-options state. Products with a real variant picker
       start from whichever pill is pre-marked pressed; products with only
       the default variant have no pills at all, so seed straight from the
       variant the server already picked (variantIdEl's value) — otherwise
       `selected` stays empty forever and findVariant() never matches anything. */
    var selected = {};
    if (optionButtons.length) {
      optionButtons.forEach(function (b) {
        if (b.getAttribute('aria-pressed') === 'true') selected[b.getAttribute('data-dp-opt-name')] = b.getAttribute('data-dp-opt-value');
      });
    } else if (variants.length) {
      var initialId = variantIdEl ? variantIdEl.value : null;
      var initV = variants.find(function (v) { return String(v.id) === String(initialId); }) || variants[0];
      if (initV && initV.optionNames) {
        initV.optionNames.forEach(function (name, i) { selected[name] = initV.options[i]; });
      }
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (val, i) {
          var name = v.optionNames ? v.optionNames[i] : null;
          return name ? selected[name] === val : true;
        });
      }) || null;
    }

    var allCtaButtons = [].slice.call(root.querySelectorAll('[data-dp-cta]'));

    function paintVariant() {
      var v = findVariant();
      var qty = getQty();
      if (v) {
        if (priceEl) priceEl.textContent = fmtMoney(v.price);
        if (wasEl) { if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = fmtMoney(v.compare_at_price); wasEl.hidden = false; } else { wasEl.hidden = true; } }
        if (variantIdEl) variantIdEl.value = v.id;
        allCtaButtons.forEach(function (btn) {
          btn.disabled = !v.available;
          var labelEl = btn.querySelector('[data-dp-cta-label]');
          var totalWrap = btn.querySelector('[data-dp-cta-totalwrap]');
          if (labelEl) labelEl.textContent = v.available ? (btn.getAttribute('data-label-add') || 'Add to cart') : (btn.getAttribute('data-label-sold') || 'Sold out');
          if (totalWrap) totalWrap.hidden = !v.available;
        });
        totalEls.forEach(function (t) { t.textContent = fmtMoney(v.price * qty); });
        if (subEl) subEl.textContent = qty + ' × ' + fmtMoney(v.price);
      } else if (allCtaButtons.length) {
        /* No variant matched at all (shouldn't normally happen) — disable
           rather than silently letting a bad add-to-cart request go out. */
        allCtaButtons.forEach(function (btn) { btn.disabled = true; });
      }
      return v;
    }

    optionButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        var name = b.getAttribute('data-dp-opt-name');
        selected[name] = b.getAttribute('data-dp-opt-value');
        optionButtons.forEach(function (o) {
          if (o.getAttribute('data-dp-opt-name') === name) o.setAttribute('aria-pressed', String(o === b));
        });
        paintVariant();
      });
    });

    /* quantity */
    var qEl = buyRoot.querySelector('[data-dp-qty]');
    var qMax = parseInt(buyRoot.getAttribute('data-max-qty') || '0', 10) || 99;
    function getQty() { return qEl ? parseInt(qEl.textContent, 10) || 1 : 1; }
    function setQty(n) { n = Math.max(1, Math.min(qMax, n)); if (qEl) qEl.textContent = n; paintVariant(); }
    var dec = buyRoot.querySelector('[data-dp-dec]'), inc = buyRoot.querySelector('[data-dp-inc]');
    if (dec) dec.addEventListener('click', function () { setQty(getQty() - 1); });
    if (inc) inc.addEventListener('click', function () { setQty(getQty() + 1); });

    paintVariant();

    /* add to cart (all [data-dp-cta] buttons share the same variant/qty state) */
    function addToCart(e) {
      var btn = e.currentTarget;
      if (btn.disabled) return;
      var v = findVariant();
      if (!v || !v.available) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: getQty() })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          flash(getQty() + '× added to cart');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          root.querySelectorAll('.dh-count').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
        })
        .catch(function () { flash('Could not add to cart — try again'); })
        .then(function () { btn.disabled = false; });
    }
    [].forEach.call(root.querySelectorAll('[data-dp-cta]'), function (b) { b.addEventListener('click', addToCart); });

    /* wishlist toggle (visual only) */
    var save = buyRoot.querySelector('[data-dp-save]');
    if (save) save.addEventListener('click', function () {
      var on = save.getAttribute('aria-pressed') !== 'true';
      save.setAttribute('aria-pressed', String(on));
      save.textContent = on ? '♥' : '♡';
      flash(on ? 'Saved to your list' : 'Removed from saved');
    });
  }

  /* ---------- tabs ----------------------------------------------------- */
  [].forEach.call(root.querySelectorAll('[data-dp-tabs]'), function (tabsEl) {
    var buttons = [].slice.call(tabsEl.querySelectorAll('[data-dp-tab]'));
    var panels = [].slice.call(tabsEl.parentNode.querySelectorAll('[data-dp-tabpanel]'));
    buttons.forEach(function (b, i) {
      b.addEventListener('click', function () {
        buttons.forEach(function (o, j) { o.setAttribute('aria-selected', String(i === j)); });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      });
    });
  });

  /* ---------- related rail: drag + arrows ------------------------------- */
  [].forEach.call(root.querySelectorAll('[data-dp-rail]'), function (rail) {
    var down = false, sx = 0, sl = 0, lx = 0, lt = 0, v = 0, moved = false, glide = null;
    function stop() { if (glide) cancelAnimationFrame(glide); glide = null; }
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      /* let touch use native scrolling — see dl-homepage.js for why */
      if (e.pointerType === 'touch') return;
      down = true; moved = false; stop();
      sx = lx = e.clientX; sl = rail.scrollLeft; lt = performance.now(); v = 0; rail.style.cursor = 'grabbing';
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true;
      rail.scrollLeft = sl - dx;
      var now = performance.now(), dt = now - lt;
      if (dt > 8) { v = (e.clientX - lx) / dt; lx = e.clientX; lt = now; }
      if (moved && e.cancelable) e.preventDefault();
    });
    function up() {
      if (!down) return;
      down = false; rail.style.cursor = 'grab';
      var vel = v * 16;
      function run() { vel *= 0.94; rail.scrollLeft -= vel; glide = Math.abs(vel) > 0.4 ? requestAnimationFrame(run) : null; }
      if (Math.abs(vel) > 1) glide = requestAnimationFrame(run);
    }
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { rail.addEventListener(t, up); });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });
  [].forEach.call(root.querySelectorAll('[data-dp-railnav]'), function (b) {
    b.addEventListener('click', function () {
      var rail = root.getElementById ? null : null;
      var railId = b.getAttribute('data-dp-railnav-target');
      var target = railId ? root.getElementById(railId) : b.closest('section').querySelector('[data-dp-rail]');
      if (target) target.scrollBy({ left: Number(b.getAttribute('data-dp-railnav')) * 268, behavior: 'smooth' });
    });
  });

  /* related-card add-to-cart (simple variants, first available variant) */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dp-add]');
    if (!b) return;
    var id = b.getAttribute('data-dp-add');
    if (!id) return;
    b.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        flash((b.getAttribute('data-dp-add-name') || 'Item') + ' added to cart');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        root.querySelectorAll('.dh-count').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      })
      .catch(function () { flash('Could not add to cart — try again'); })
      .then(function () { b.disabled = false; });
  });
})();
